module.exports = __webpack_public_path__ + "static/location-info4-c31b955de98b3264469a0002c9fc32ba.jpg";